import {useEffect, useState} from 'react';
import {
  MESSAGE_DRAFTS_STORAGE_KEY,
  draftKey,
  getActiveDraftKeys,
  type MessageDraftKeyParts,
} from '@/utils/message-drafts/messageDrafts';
import Storage from '@/utils/wrappers/Storage';
import useDashboardUserQuery from '@/hooks/queries/use-dashboard-user-query';

type DraftLookupParts = Omit<MessageDraftKeyParts, 'dashboardUserId'>;

/**
 * Subscribes to the shared draft map and exposes a hasDraft lookup that
 * re-renders list/grid badges when drafts change. Lookups are scoped to the
 * authenticated dashboard user.
 */
function useMessageDraftPresence() {
  const {dashboardUser} = useDashboardUserQuery({});
  const dashboardUserId = dashboardUser.id ?? '';
  const [activeKeys, setActiveKeys] = useState<Set<string>>(() =>
    getActiveDraftKeys()
  );

  useEffect(() => {
    const sync = () => setActiveKeys(getActiveDraftKeys());
    sync();
    return Storage.addSubscriber(MESSAGE_DRAFTS_STORAGE_KEY, sync);
  }, []);

  const hasDraftFor = (parts: DraftLookupParts) => {
    if (!dashboardUserId || !parts.brandId || !parts.conversationId) {
      return false;
    }
    return activeKeys.has(draftKey({...parts, dashboardUserId}));
  };

  return {hasDraftFor, activeKeys};
}

export default useMessageDraftPresence;
